import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ManageLogin from "./pages/login/ManageLogin";
import ManageRegistration from "./pages/registration/ManageRegistration";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
